<template>
	<div>
		<div class="header-bar">
			<span>批次信息：{{ dateRangeValue }}</span>
		</div>
		<div class="tool-bar">
			<el-form :inline="true">
				<el-form-item label="系列">
					<el-select v-model="xSeries" placeholder="选择系列（横坐标）">
						<el-option v-for="item in series" :key="item.value" :label="item.label" :value="item.value"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="指标">
					<el-select v-model="ySeries" placeholder="选择指标（纵坐标）">
						<el-option v-for="item in quotas" :key="item.value" :label="item.label" :value="item.value"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间范围">
					<DateRange v-model="dateRange" :pickerOptions="pickerOptions" />
				</el-form-item>

				<el-form-item>
					<el-button type="primary" v-on:click="makeCharts" :disabled="buttonDisabled">生成统计报表</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="report-view">
			<Report />
		</div>
	</div>
</template>

<script>
	import DateRange from '@/components/DateRangePicker'
	import Report from './OtherStatReport'
	import moment from 'moment'
	import { getOutputOfDevice } from '@/service/reportService'
	import defectService from '@/service/defectService'

	export default {
		components: {
			// eslint-disable-next-line vue/no-unused-components
			DateRange,
			Report,
		},
		data() {
			this.quotas = [
				{ label: '产量', value: 1 },
				{ label: '良率', value: 2 },
				{ label: '调机时间', value: 3 },
				{ label: '调机米数', value: 4 },
				{ label: '缺陷', value: 5 },
			]
			this.series = [
				{ label: '设备', value: 1 },
				{ label: '工单', value: 2 },
				{ label: '人员', value: 3 },
				{ label: '工艺', value: 4 },
				{ label: '车间', value: 5 },
				{ label: '班次', value: 6 },
			]

			var self = this

			return {
				xSeries: 1,
				ySeries: 1,
				dateRange: [],
				dateRangeValue: 0,
				pickerOptions: {
					shortcuts: [
						{
							text: '近十天',
							onClick(picker) {
								const end = new Date()
								const start = moment()
									.subtract(10, 'days')
									.toDate()

								console.log('近十天', start, end)
								picker.$emit('pick', [start, end])
								self.setDateRangeValue(1)
							},
						},
						// {
						// 	text: '近一个月',
						// 	onClick(picker) {
						// 		const end = new Date()
						// 		const start = moment()
						// 			.subtract(1, 'months')
						// 			.toDate()

						// 		picker.$emit('pick', [start, end])
						// 		self.setDateRangeValue(2)
						// 	},
						// },
						{
							text: '近六个月',
							onClick(picker) {
								const end = new Date()
								const start = moment()
									.subtract(6, 'months')
									.toDate()

								picker.$emit('pick', [start, end])
								self.setDateRangeValue(3)
							},
						},
						{
							text: '近5年',
							onClick(picker) {
								const end = new Date()
								const start = moment()
									.subtract(5, 'years')
									.toDate()

								picker.$emit('pick', [start, end])
								self.setDateRangeValue(4)
							},
						},
					],
					onPick(maxDate, minDate) {
						console.log('选择：', maxDate, minDate)
						self.setDateRangeValue(0)
					},
				},
			}
		},
		computed: {
			buttonDisabled() {
				return !(this.xSeries && this.ySeries)
			},
		},
		methods: {
			setDateRangeValue(val) {
				this.dateRangeValue = val
			},
			/**
			 * 获取日期分组。
			 */
			getDateRangeGroup() {
				var array = []

				if (this.dateRangeValue == 1) {
					//近十天。
					for (let i = 0; i < 10; i++) {
						const st = moment(this.dateRange[0]).add(i, 'days')
						const et = moment(this.dateRange[0]).add(i + 1, 'days')
						array.push({ startTime: st.unix(), endTime: et.unix() })
					}
				} else if (this.dateRangeValue == 3) {
					//近6个月。
					for (let i = 0; i < 6; i++) {
						const st = moment(this.dateRange[0]).add(i, 'months')
						const et = moment(this.dateRange[0]).add(i + 1, 'months')
						array.push({ startTime: st.unix(), endTime: et.unix() })
					}
				} else if (this.dateRangeValue == 3) {
					//近5年。
					for (let i = 0; i < 5; i++) {
						const st = moment(this.dateRange[0]).add(i, 'years')
						const et = moment(this.dateRange[0]).add(i + 1, 'years')
						array.push({ startTime: st.unix(), endTime: et.unix() })
					}
				}

				return array
			},
			makeCharts() {
				//日期分组。
				var dateGroups = this.getDateRangeGroup()

				//获取机台。
				defectService.getDefectStatList()

				console.log(dateGroups)

				//设备-产量
				getOutputOfDevice(['5ee721ff23f1119f6663ebb3', '5f1caeb531a3d49a4929d7d0'], dateGroups).then(res => {
					console.log(res)
				})

				//const newRouter = this.$router.resolve({ name: 'ControlMonitorOtherReport', query: { x: this.xSeries, y: this.ySeries } })
				//window.open(newRouter.href, '_blank')
			},
		},
		created() {},
	}
</script>

<style lang="less" scoped>
	.header-bar {
		padding: 5px 20px;
		font-size: 13px;
		background-color: #fff;
		border-bottom: 1px #eee solid;
	}
	.tool-bar {
		background-color: #f1f1f1;
		padding: 20px 20px 0;
	}

	.report-view {
		padding: 0 20px;
	}
</style>
